import { render, staticRenderFns } from "./BusinessShareholdersAgreementYN.vue?vue&type=template&id=4e0e0c60"
import script from "./BusinessShareholdersAgreementYN.vue?vue&type=script&lang=js"
export * from "./BusinessShareholdersAgreementYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports